import React from 'react';
import { FormattedMessage } from 'react-intl';
import Wrapper from './wrapper';

const TextField = ({ input, meta, placeholder, type, className, onEnter }) => {
  const { touched, error } = meta;

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  return (
    <Wrapper className={`form-group ${className}`} error={touched && error}>
      <input
        {...input}
        type={type}
        placeholder={placeholder}
        className={`form-control ${touched && error ? 'is-invalid' : ''}`}
        onKeyPress={handleKeyPress}
      />
      {touched && error && (
        <div className="error-message">
          <FormattedMessage
            id={`Validation.error.${error}`}
            defaultMessage={error}
          />
        </div>
      )}
    </Wrapper>
  );
};

export default TextField;
